$(document).ready(function() {


  $('.custom_qty').click(function(e) {
      var data = {
          items: [{
              'id': $('[name="id"]').val(),
              'quantity': 10
          }]
      }
  
      e.preventDefault();
      fetch('/cart/add.js', {
              body: JSON.stringify(data),
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'xmlhttprequest'
              },
              method: 'POST'
          })
          .then(success => {
              console.log(data);
              // GetData();
            alert("10 pack added ");
            window.location.href = '/cart';
          });
      
  });

  // 5 pack
  $('.custom_qty_five').click(function(e) {
      var data = {
          items: [{
              'id': $('[name="id"]').val(),
              'quantity': 5
          }]
      }
  
      e.preventDefault();
      fetch('/cart/add.js', {
              body: JSON.stringify(data),
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'xmlhttprequest'
              },
              method: 'POST'
          })
          .then(success => {
              console.log(data);
              // GetData();
            alert("5 pack added ");
            window.location.href = '/cart';
          });
      
  });

var productLinks = document.querySelectorAll('.product-link');
  for (var i = 0; i < productLinks.length; i++) {
    productLinks[i].addEventListener('click', function(e) {
      e.preventDefault();
      var href = this.getAttribute('href');
      history.pushState(null, null, href);
      location.reload();
    });
  }


 

});